const ABSOLUTE_SCHEME = /^(?:https?:|blob:|data:)/i;

export const resolveLogoUrl = (value, apiUrl, frontendOrigin) => {
  if (!value) return null;
  const source = String(value).trim();
  if (!source) return null;
  if (ABSOLUTE_SCHEME.test(source)) return source;

  const browserOrigin = frontendOrigin
    || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
  try {
    const backendOrigin = new URL(apiUrl || '/', browserOrigin).origin;
    return new URL(source, `${backendOrigin}/`).toString();
  } catch (error) {
    return source;
  }
};

export const addLogoCacheVersion = (url, version) => {
  if (!url || !version || /^(?:blob:|data:)/i.test(url)) return url;
  try {
    const parsed = new URL(url);
    parsed.searchParams.set('v', String(version));
    return parsed.toString();
  } catch (error) {
    return url;
  }
};

export const getPersistedLogoUrl = ({ logo, ultimaModificacion, apiUrl, frontendOrigin }) => (
  addLogoCacheVersion(resolveLogoUrl(logo, apiUrl, frontendOrigin), ultimaModificacion)
);
